import { ref } from "vue";
import {
  sendQuoteEmailViaBackend,
  type BuildNotifyQuoteParams,
  type SendQuoteNotifyResponse,
} from "@/services/emailBackendService";

export type BuildNotifyEmailParams = Omit<BuildNotifyQuoteParams, "canales"> & {
  email: string;
};

/** @deprecated Alias. */
export type SendQuoteEmailResponse = SendQuoteNotifyResponse;

export const useEmail = () => {
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  const sendQuoteEmail = async (
    params: BuildNotifyEmailParams,
  ): Promise<SendQuoteNotifyResponse> => {
    isLoading.value = true;
    error.value = null;

    try {
      const result = await sendQuoteEmailViaBackend(params);

      if (!result.success) {
        error.value = result.error || "Error al enviar el email";
      }

      return result;
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "Error desconocido al enviar email";
      error.value = errorMessage;

      return {
        success: false,
        error: errorMessage,
      };
    } finally {
      isLoading.value = false;
    }
  };

  const clearError = () => {
    error.value = null;
  };

  return {
    isLoading,
    error,
    sendQuoteEmail,
    clearError,
  };
};
